import { fetchLoggin, fetchPasswordValidity, fetchGetBody } from "../../helpers/fetch";
import { types } from "../../types/types";
import { calcMD5 } from "../../helpers/md5";
import { ShowMessage } from "../../componets/showMessage/ShowMessage";
import bcryptjs from "bcryptjs";

export const startLoginAfiliado = (
    {
        username,
        password,
        keyClient,
        nit,
        nitSelect,
        idiomaSelect,
        captcha,
        code,
        setShowLoader,
        TexTranslate,
        intl,
        app,
        setShowTimer,
        setLoadingTime,
        history,
        loginCore,
        processResponseLoginCore
    }) => {

    return async (dispatch) => {

        const idioma = idiomaSelect || 'es';
        const passwordBcrypt = await bcryptjs.hash(password, app.salt);
        let passEncr = code != undefined ? password : calcMD5(password);
        let jsonDataAuth;
        let loginResponse;
        let msgProcessLoginCore;

        let data = {
            username,
            "psxm": passwordBcrypt,
            "ctlx": captcha,
            "mcin": passEncr
        };
        if (code !== undefined) {
            data["code"] = code;
        }
        data["language"] = idioma || 'es'
        let resp = await fetchLoggin(data, 'POST', app);
        let waitTimeFromFirst;
        let body;

         if(resp.ok){
                data.password = passwordBcrypt;
                data.passwordBcrypt = true;
            }

        
        if (!resp.ok && resp.status === 400) {
            try {
                body = await resp.json();
                waitTimeFromFirst = body?.waitTime ?? body?.bloqueo;
            } catch (e) {
                body = {};
            }
            if (waitTimeFromFirst !== undefined && waitTimeFromFirst !== null) {
                setShowLoader(false);
                setLoadingTime(waitTimeFromFirst ?? 60);
                setShowTimer(true);
                return;
            }
        
        }

        if (body === undefined) {
            try {
                body = await resp.json();
            } catch (e) {
                body = {};
            }
        }

        const waitTimeValue = body?.waitTime ?? waitTimeFromFirst ?? body?.bloqueo;
        const hasWaitTime = waitTimeValue !== undefined && waitTimeValue !== null;

        if (hasWaitTime && !body?.access_token) {
            setShowLoader(false);
            setLoadingTime(waitTimeValue ?? 60);
            setShowTimer(true);
            return;
        }

        if (!resp.ok && resp.status === 401) {
            if (body.error_description === "Bloqueo") {
                setShowLoader(false);
                setLoadingTime(waitTimeValue ?? 60);
                setShowTimer(true);
                return;
            } else if (body.error_description === "Expired") {
                setShowLoader(false);
                dispatch(login({expired: true, "nit" : nit, "nitSelect" : nitSelect}));
                history.push(`/${app.baseName}/changePassMandatory.html`, {});
                return;
            }

            setShowLoader(false);
            if (!hasWaitTime) {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        intl
                    }
                )
            }
            dispatch(checkingFinish());
            setLoadingTime(waitTimeValue ?? 60);
            setShowTimer(true);
        } else if (body.access_token) {

                const respBody = await fetchGetBody(app, body.access_token);
                const tokenJson = respBody.userData;

                if (tokenJson) {
                    const value = {
                        token: body.access_token,
                        idioma: idioma
                    }
                    const dataLoginCore = { "value": value }
                    if (keyClient) {
                        dataLoginCore.keyClient = keyClient;
                    }
                    loginResponse = await loginCore(dataLoginCore);

                    if (loginResponse?.success) {
                        jsonDataAuth = (tokenJson.type_user).toLowerCase();

                        if (jsonDataAuth === 'supplier') {
                            sessionStorage.setItem('userRedirect', body.access_token);
                            sessionStorage.setItem('landing', nit);
                            sessionStorage.setItem('nitSelect', nitSelect);
                            sessionStorage.setItem('idioma', idioma);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            if(sessionStorage.getItem("guardiaTimeOut")){
                                clearTimeout(sessionStorage.getItem("guardiaTimeOut"));
                                sessionStorage.removeItem("guardiaTimeOut");
                            }
                            dispatch(login({ loginAfiliado: { "access_token" : body.access_token, "nit" : nit, "nitSelect" : nitSelect } }));
                            history.push(`/${app.baseName}/acceso/${nit}/landing`);
                        } else if (jsonDataAuth === 'admin') {
                            sessionStorage.setItem('userRedirect', body.access_token);
                            sessionStorage.setItem('landingAdmin', nit);
                            sessionStorage.setItem('nitSelect', nitSelect);
                            sessionStorage.setItem('idioma', idioma);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            dispatch(login({ "access_token" : body.access_token }));
                        } else if (jsonDataAuth === "funder") {
                            window.location.href = `${app.apiCore}/Funder.jsp?lang_user=${idioma || 'es'}`
                        } else {
                            setShowLoader(false);
                            console.log("typeUser.error");
                        }


                    } else {
                        msgProcessLoginCore = processResponseLoginCore({
                            "msg": loginResponse.msg,
                            "msgParams": loginResponse,
                            "TexTranslate": TexTranslate,
                            "intl": intl
                        });
                        setShowLoader(false);

                        if (msgProcessLoginCore) {
                            ShowMessage(
                                {
                                    title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                    message: msgProcessLoginCore,
                                    typeMessage: "warning",
                                    showCancelButton: false,
                                    intl
                                }
                            );
                        } else {
                            ShowMessage(
                                {
                                    title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                    message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                                    typeMessage: "warning",
                                    showCancelButton: false,
                                    intl
                                }
                            );
                        }
                        dispatch(checkingFinish());
                    }


                } else {
                    setShowLoader(false);
                }
            

        } else {
            setShowLoader(false);
            if (!hasWaitTime) {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        intl
                    }
                )
            }
            dispatch(checkingFinish());
            setLoadingTime(waitTimeValue ?? 60);
            setShowTimer(true);
        }
    }

}


const checkingFinish = () => ({
    type: types.authCheckingFinish
})

const login = (user) => ({
    type: types.authLogin,
    payload: user
})
